"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geekblue = exports.cyan = exports.blue = void 0;
Object.defineProperty(exports, "generate", {
  enumerable: true,
  get: function get() {
    return _generate.default;
  }
});
exports.yellow = exports.volcano = exports.red = exports.purple = exports.presetPrimaryColors = exports.presetPalettes = exports.presetNeutralPalette = exports.presetDarkPalettes = exports.orange = exports.magenta = exports.lime = exports.grey = exports.green = exports.gold = exports.generatePalettes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _generate = _interopRequireDefault(require("./generate"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defultColors = {
  primary: '#4691FB',
  secondary: '#17c6ff',
  default: '#3a3c44',
  success: '#8CC63E',
  warning: '#FF9C00',
  danger: '#F8564D',
  info: '#4691FB'
};

/**
 * ### new -> old ###
 * blue -> primary
 * blue -> info
 * cyan -> secondary
 * grey -> default
 * green -> success
 * yellow -> warning
 * red -> danger
 * red -> error
 */

// Tasarimcilardan Sparx icin de `volcano, orange, gold, lime, geekblue, purple, magenta` vermelerini isteyebiliriz.
// Su anda, bu renkleri Ant tan gelen default halleri ile biraktim
var presetPrimaryColors = exports.presetPrimaryColors = {
  red: '#F8564D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FF9C00',
  lime: '#A0D911',
  green: '#8CC63E',
  cyan: '#17c6ff',
  blue: '#4691FB',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#3a3c44'
};

// Ant Design defaults
// const presetPrimaryColors = {
//   red: '#F5222D',
//   volcano: '#FA541C',
//   orange: '#FA8C16',
//   gold: '#FAAD14',
//   yellow: '#FADB14',
//   lime: '#A0D911',
//   green: '#52C41A',
//   cyan: '#13C2C2',
//   blue: '#1890FF',
//   geekblue: '#2F54EB',
//   purple: '#722ED1',
//   magenta: '#EB2F96',
//   grey: '#666666',
// };

var presetPalettes = exports.presetPalettes = {};
var presetDarkPalettes = exports.presetDarkPalettes = {};
var presetNeutralPalette = exports.presetNeutralPalette = {
  neutral1: '#ffffff',
  neutral2: '#fafafa',
  neutral3: '#f5f5f5',
  neutral4: '#f0f0f0',
  neutral5: '#d9d9d9',
  neutral6: '#bfbfbf',
  neutral7: '#8c8c8c',
  neutral8: '#595959',
  neutral9: '#434343',
  neutral10: '#262626',
  neutral11: '#1f1f1f',
  neutral12: '#141414',
  neutral13: '#000000'
};
var namedPresetPalettes = {};
var generatePalettes = exports.generatePalettes = function generatePalettes(colors) {
  exports.presetPrimaryColors = presetPrimaryColors = colors ? colors : presetPrimaryColors;
  Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = (0, _generate.default)(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];

    // dark presetPalettes
    presetDarkPalettes[key] = (0, _generate.default)(presetPrimaryColors[key], {
      theme: 'dark',
      backgroundColor: '#141414'
    });
    presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
  });
  Object.keys(presetPalettes).map(function (colorName) {
    presetPalettes[colorName].map(function (color, index) {
      namedPresetPalettes["".concat(colorName).concat(index + 1)] = presetPalettes[colorName][index];
    });
  });
  return _objectSpread(_objectSpread({}, namedPresetPalettes), presetNeutralPalette);
};
generatePalettes();
var red = exports.red = presetPalettes.red;
var volcano = exports.volcano = presetPalettes.volcano;
var gold = exports.gold = presetPalettes.gold;
var orange = exports.orange = presetPalettes.orange;
var yellow = exports.yellow = presetPalettes.yellow;
var lime = exports.lime = presetPalettes.lime;
var green = exports.green = presetPalettes.green;
var cyan = exports.cyan = presetPalettes.cyan;
var blue = exports.blue = presetPalettes.blue;
var geekblue = exports.geekblue = presetPalettes.geekblue;
var purple = exports.purple = presetPalettes.purple;
var magenta = exports.magenta = presetPalettes.magenta;
var grey = exports.grey = presetPalettes.grey;